import { CloseRounded } from "@mui/icons-material";
import { Box, Dialog, Divider, IconButton, Tab, Tabs, Typography } from "@mui/material";
import { ReactNode, useState } from "react";
import { black, greyEnabled, purple } from "../../theme/colors";

interface BulkUploadDialogShellProps {
  open: boolean;
  onClose: () => void;
  title: string;
  createTabLabel: string;
  translationsTabLabel: string;
  createTabContent: ReactNode;
  translationsTabContent: ReactNode;
}

// Shared chrome (header + Create/Translations tabs) for every module's bulk
// upload dialog - only the two tabs' own BulkUploadSection content differs
// per module.
export default function BulkUploadDialogShell({
  open,
  onClose,
  title,
  createTabLabel,
  translationsTabLabel,
  createTabContent,
  translationsTabContent,
}: BulkUploadDialogShellProps) {
  const [tab, setTab] = useState(0);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 4 } }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{ px: 3, pt: 2.5, pb: 1.5, borderBottom: "1px solid #ECECEC" }}
      >
        <Typography variant="h6" fontWeight={700} color={black}>
          {title}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseRounded sx={{ color: greyEnabled }} />
        </IconButton>
      </Box>

      <Tabs
        value={tab}
        onChange={(_, value) => setTab(value)}
        TabIndicatorProps={{ style: { backgroundColor: purple, height: 3, borderRadius: 3 } }}
        sx={{ px: 2 }}
      >
        <Tab label={createTabLabel} sx={{ textTransform: "none", fontWeight: 600, color: greyEnabled, "&.Mui-selected": { color: purple } }} />
        <Tab label={translationsTabLabel} sx={{ textTransform: "none", fontWeight: 600, color: greyEnabled, "&.Mui-selected": { color: purple } }} />
      </Tabs>
      <Divider />

      <Box sx={{ px: 3, py: 3 }}>
        {tab === 0 && createTabContent}
        {tab === 1 && translationsTabContent}
      </Box>
    </Dialog>
  );
}
